import React, { Component } from 'react';
import { Link } from "react-router-dom";
import BannerFadeIn from "./../../components/bannerFadeIn";
import Footer from './../../components/footer';
import FlodeskForm from './../../components/flodeskForm';
import {Helmet} from "react-helmet";

export default class Notify extends Component {

  render() {
    let padding = "100px";
    if(window.outerWidth < 800){
      padding = "20px";
    }
    return (
      <div>
        <Helmet>
          <title>{'Notify When Available Kat Medina'}</title>
          <meta name="description" content="Be the first to know when this kickass book, The Joys of Jet Lag, is available. Written by Kat Medina." />
        </Helmet>
        <BannerFadeIn>
          <div id="hero" className="hero full-height full-width">
            <div className="hero-content mobile-black-glas row" style={{padding:padding,minHeight:window.innerHeight,alignItems:"center", justifyContent:"center"}}>
              <div className="small-padding small-max-width-container" style={{maxWidth:"800px"}}>
                <FlodeskForm segment="Notify Me" />
              </div>
            </div>
            <div id="hero-background" className="hero-background" style={{backgroundImage: "url(/images/notified.jpg)", backgroundPosition:"top"}}></div>
          </div>
        </BannerFadeIn>
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/notify/index.js